import { render, staticRenderFns } from "./FormBase.vue?vue&type=template&id=30a206d8"
import script from "./FormBase.vue?vue&type=script&lang=js"
export * from "./FormBase.vue?vue&type=script&lang=js"
import style0 from "./FormBase.vue?vue&type=style&index=0&id=30a206d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports